export interface Product {
  id: number;
  name: string;
  nameEn: string;
  category: string;
  priceLabel: string;
  description: string;
  bgColor: string;
  accentColor: string;
  badge?: string;
}

export const products: Product[] = [
  {
    id: 1,
    name: '골든 크레스트 엠블럼',
    nameEn: 'Golden Crest Emblem',
    category: 'BULLION EMBLEM',
    priceLabel: '가격문의',
    description: '순금 불리온 와이어로 제작된 최고급 크레스트 엠블럼. 고급스러운 광택과 정교한 디테일.',
    bgColor: '#2C2C2C',
    accentColor: '#C9A961',
    badge: 'PREMIUM',
  },
  {
    id: 2,
    name: '로열 에포렛',
    nameEn: 'Royal Epaulette',
    category: 'BULLION EMBLEM',
    priceLabel: '가격문의',
    description: '군사·예복용 전통 에포렛 핸드메이드 제작. 정밀한 불리온 프린지 처리.',
    bgColor: '#1A1A1A',
    accentColor: '#E8D5A3',
    badge: 'SIGNATURE',
  },
  {
    id: 3,
    name: '실크 플로럴 자수',
    nameEn: 'Silk Floral Embroidery',
    category: 'HANDMADE EMBROIDERY',
    priceLabel: '가격문의',
    description: '100% 실크 실을 사용한 섬세한 플로럴 패턴 핸드메이드 자수.',
    bgColor: '#3D3D3D',
    accentColor: '#C9A961',
  },
  {
    id: 4,
    name: '로고 패치 자수',
    nameEn: 'Logo Patch Embroidery',
    category: 'CUSTOM ORDER',
    priceLabel: '가격문의',
    description: '브랜드 로고를 정교하게 자수로 재현하는 맞춤 제작 서비스.',
    bgColor: '#2C2C2C',
    accentColor: '#E8D5A3',
    badge: 'CUSTOM',
  },
  {
    id: 5,
    name: '금장 군모 엠블럼',
    nameEn: 'Military Cap Emblem',
    category: 'BULLION EMBLEM',
    priceLabel: '가격문의',
    description: '정통 군모 및 예복 모자용 금장 엠블럼. 입체감 있는 불리온 와이어 공정.',
    bgColor: '#1A1A1A',
    accentColor: '#C9A961',
  },
  {
    id: 6,
    name: '르네상스 태피스트리',
    nameEn: 'Renaissance Tapestry',
    category: 'HANDMADE EMBROIDERY',
    priceLabel: '가격문의',
    description: '유럽 전통 태피스트리 기법으로 제작된 고급 벽걸이 자수 작품.',
    bgColor: '#3D3D3D',
    accentColor: '#C9A961',
    badge: 'LIMITED',
  },
  {
    id: 7,
    name: '클래식 보더 레이스',
    nameEn: 'Classic Border Lace',
    category: 'HANDMADE EMBROIDERY',
    priceLabel: '가격문의',
    description: '전통 레이스 기법을 현대적으로 재해석한 보더 자수.',
    bgColor: '#2C2C2C',
    accentColor: '#E8D5A3',
  },
  {
    id: 8,
    name: '프레지덴셜 배지',
    nameEn: 'Presidential Badge',
    category: 'BULLION EMBLEM',
    priceLabel: '가격문의',
    description: '국가 및 기관용 고품격 배지. 순금·은 도금 마감 처리 가능.',
    bgColor: '#1A1A1A',
    accentColor: '#C9A961',
    badge: 'EXCLUSIVE',
  },
];
